import { useEffect, useState } from "react";

import useAxios from "@src/utility/hooks/use-axios";
import { useParams } from "react-router-dom";
import useSearchParams from "@src/utility/hooks/use-search-params";

const useDetails = () => {
    const [active, setActive] = useState("tasks");
    const [details, setDetails] = useState({
        attributes  : {},
        segments    : [],
        healthScores: {}
    });
    const [modalConfig, setModalConfig] = useState({
        isOpen: false,
        row   : {}
    });

    const handleModal = (row = {}) => {
        setModalConfig({
            isOpen: !modalConfig.isOpen,
            row
        });
    };
    const { createSearchParams, getSearchParams } = useSearchParams();
    const { clientId, platformId } = useParams();
    const activeTab = String(getSearchParams("tab")) || active;
    const { axiosInstance, loading, cancelAllRequests } = useAxios({
        base         : "panel",
        initialLoader: true
    });

    const toggle = id => {
        setActive(id);
        createSearchParams("tab", id);
    };

    useEffect(() => {
        if (activeTab) {
            setActive(activeTab);
        }
    }, []);

    const fetchDetails = async () => {
        const response = await axiosInstance.get(
            `/dashboard/${platformId}/company/${clientId}`
        );
        setDetails({
            attributes  : response.data.clientAttributes,
            segments    : response.data.clientSegments,
            healthScores: response.data.clientHealthScore
        });
    };

    useEffect(() => {
        fetchDetails();
        return () => {
            cancelAllRequests();
        };
    }, []);

    return {
        toggle,
        active,
        loading,
        details,
        fetchDetails,
        handleModal,
        modalConfig
    };
};
export default useDetails;
